import "styles/landing-pages/blogs.less";
import { useRef, useState, useEffect, useMemo } from "react";

import { Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { IBlogUK } from "types/blogUK";
import { scrollToTop } from "utils/common";
import LazyLoadedImage from "utils/LazyLoadedImage";

const contentful = require("contentful");

const client = contentful.createClient({
    space: "w0hcz4e46cwo",
    accessToken: "OEsI882KvnNdRBQ5iQXclL8wRzJZHD65Ah99KvmsPLg",
});

const TaxzapBlog = () => {
    const swiperRef = useRef<any>(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const navigate = useNavigate();

    const screenSize = useMemo(() => {
        if (windowWidth < 576) return "extraSmall";
        if (windowWidth < 768) return "small";
        if (windowWidth < 992) return "medium";
        if (windowWidth < 1200) return "large";
        return "extraLarge";
    }, [windowWidth]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleMenuClick = (
        link: string
    ) => {
        if (link) {
            navigate(`/${link}`);
            scrollToTop();
        }
    };

    const [blogs, setBlogs] = useState<IBlogUK[]>([]);

    async function handleResponse(): Promise<IBlogUK[]> {
        try {
            const response = await client.getEntries({
                content_type: "newUkBlogPost",
            });
            const blogs = response.items;
            return blogs;
        } catch (error) {
            console.error("Error fetching blog posts:", error);
            return [];
        }
    }

    useEffect(() => {
        handleResponse().then(response => setBlogs(response));
    }, []);

    return (
        <div className="blogs mb20">
            <div className="section-title mb20">TaxZap Blogs</div>
            <Swiper
                {...({ slidesPerView: screenSize === "extraSmall" ? 1 : screenSize === "small" ? 1.5 : screenSize === "medium" ? 2.1 : screenSize === "large" ? 2.5 : 3 } as any)}
                {...({ spaceBetween: 15 } as any)}
                onSwiper={(swiper: any) => { swiperRef.current = swiper; }}
            >
                {blogs.map((blog, index) => (
                    <SwiperSlide key={index} onClick={() => { handleMenuClick(blog.fields.link); }}>
                        <div>
                            <Row justify="space-between" className="w100">
                                <Col>
                                    <Row>
                                        <LazyLoadedImage
                                            className="blogs__blog-image"
                                            src={blog.fields.image.fields.file.url}
                                            alt={blog.fields.alt}
                                        />
                                    </Row>
                                </Col>
                                <Col>
                                    <Typography.Paragraph className="blogs__blog-content" ellipsis={{ rows: 4, expandable: true, symbol: "more" }}>
                                        {blog.fields.content}
                                    </Typography.Paragraph>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={3}>
                                    <LazyLoadedImage className="blogs__blog-author-image" src={blog.fields.authorImage.fields.file.url} alt="author" />
                                </Col>
                                <Col span={21}>
                                    <Typography className="blogs__blog-author-text">
                                        {blog.fields.author}
                                    </Typography>
                                    <Typography className="blogs__blog-author-subtext" >
                                        {blog.fields.date}
                                    </Typography>
                                </Col>
                            </Row>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>

    );
};

export default TaxzapBlog;
